import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { CustomFiltersActionType, CustomFiltersFilter, CustomFiltersStore } from './CustomFiltersReducer.types';

const initialFilters = {
  typeValue: '',
  operatorValue: '',
  filterValue: '',
  filterCategory: undefined,
};

// @ts-ignore
const initialState: CustomFiltersStore = Immutable.fromJS({
  alphas: {
    filters: [initialFilters],
    appliedFilters: [],
    savedFilterSelected: undefined,
  },
});

const CustomFiltersReducer = handleActions<any>(
  {
    CHANGE_TYPE: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      // @ts-ignore
      const newFilters = state.getIn([action.payload.filterName, 'filters']).map((filter: any, index: number) => {
        if (index === action.payload.index) {
          return filter.merge(
            filter,
            Immutable.fromJS({
              typeValue: action.payload.value,
              operatorValue: '',
              filterValue: '',
              filterCategory: action.payload.category,
            })
          );
        } else {
          return filter;
        }
      });

      return state
        .setIn([action.payload.filterName, 'filters'], newFilters)
        .setIn([action.payload.filterName, 'savedFilterSelected'], undefined);
    },

    CHANGE_OPERATOR: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      // @ts-ignore
      const newFilters = state.getIn([action.payload.filterName, 'filters']).map((filter: any, index: number) => {
        if (index === action.payload.index) {
          return filter.merge(
            Immutable.fromJS({
              operatorValue: action.payload.value,
              filterCategory: action.payload.category,
            })
          );
        } else {
          return filter;
        }
      });

      return state
        .setIn([action.payload.filterName, 'filters'], newFilters)
        .setIn([action.payload.filterName, 'savedFilterSelected'], undefined);
    },

    CHANGE_FILTER_VALUE: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      // @ts-ignore
      const newFilters = state.getIn([action.payload.filterName, 'filters']).map((filter: any, index: number) => {
        if (index === action.payload.index) {
          return filter.merge(
            Immutable.fromJS({
              filterValue: action.payload.value,
            })
          );
        } else {
          return filter;
        }
      });

      return state
        .setIn([action.payload.filterName, 'filters'], newFilters)
        .setIn([action.payload.filterName, 'savedFilterSelected'], undefined);
    },

    REMOVE_FILTER: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      // @ts-ignore
      const newFilters = state
        .getIn([action.payload.filterName, 'filters'])
        .filter((__: CustomFiltersFilter, index: number) => index !== action.payload.index);

      return state
        .setIn([action.payload.filterName, 'filters'], newFilters)
        .setIn([action.payload.filterName, 'savedFilterSelected'], undefined);
    },

    CHANGE_SAVED_FILTER_SELECTED: (state: CustomFiltersStore, action: CustomFiltersActionType) =>
      state.setIn([action.payload.filterName, 'savedFilterSelected'], action.payload.index),

    REMOVE_APPLIED_FILTER: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      // @ts-ignore
      const newFilters = state
        .getIn([action.payload.filterName, 'appliedFilters'])
        .filter((__: CustomFiltersFilter, index: number) => index !== action.payload.index);

      return state.setIn([action.payload.filterName, 'appliedFilters'], newFilters);
    },

    CLEAN_FILTER: () => initialState,

    SET_FILTERS: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      if (action.payload.filters) {
        return state
          .setIn([action.payload.filterName, 'filters'], action.payload.filters.concat(Immutable.fromJS([initialFilters])))
          .setIn([action.payload.filterName, 'savedFilterSelected'], undefined);
      } else {
        return state;
      }
    },

    SET_FILTERS_APPLIED: (state: CustomFiltersStore, action: CustomFiltersActionType) => {
      if (action.payload.filters) {
        let newFilters: any = state.getIn([action.payload.filterName, 'filters']);
        // @ts-ignore
        if (action.payload.index !== undefined && action.payload.index + 1 === state.getIn([action.payload.filterName, 'filters']).size) {
          newFilters = newFilters.push(Immutable.fromJS(initialFilters));
        }

        return state
          .setIn([action.payload.filterName, 'appliedFilters'], Immutable.fromJS(action.payload.filters))
          .setIn([action.payload.filterName, 'filters'], newFilters);
      } else {
        return state;
      }
    },
  },
  initialState
);

export default CustomFiltersReducer;
